import {BACKEND_API_LOYALTY, SECRET_KEY_MYVNPT_VINAPHONE_PLUS_FOR_WEB} from "../global/environment";
import {v4 as uuidv4} from "uuid";
import {postRequest, postRequestLoyalty} from "../utils/http";
import cryptoJs from "crypto-js";
import sha256 from "crypto-js/sha256";


const baseURLVPlusLoyalty = BACKEND_API_LOYALTY;
const secretKey = SECRET_KEY_MYVNPT_VINAPHONE_PLUS_FOR_WEB;
//213
const msisdn = localStorage.getItem('mobile') || "";


const setHeaders = () => {
    const Authorization = "Bearer a60bd62fed0cf1076e93af76114f196bd9c5a48155b2bac88afe15c49595414b";
    return {
        Authorization,
        "Device-Info": "WEB",
        Language: localStorage.getItem('language') ? (localStorage.getItem('language') === "en-US" ? "en_US" : localStorage.getItem('language')) : "vi_VN"
    };
};
const setRequest = () => {
    // const secureCode = sha256(uuid + "|" + (msisdn === localStorage.getItem("mobile") ? msisdn : localStorage.getItem("mobile") ? localStorage.getItem("mobile") : "") + "|" + partnerCode + "|" + secretKey).toString(cryptoJs.enc.Hex);
    return {
        requestId: uuidv4(),
        msisdn: localStorage.getItem('mobile') || "",
        session: localStorage.getItem('session') || "",
        partnerCode: "WEB_MYVNPT" // Đối với kênh WEB cần truyền partnerCode
    };
};


export const LoyaltyService = {
    getMemberInfo: function (data, successCallback, failCallback) {
        console.log("const msisdn", msisdn);
        console.log("localStorage.getItem('mobile')", setRequest()?.msisdn);
        const URL = `${baseURLVPlusLoyalty}/getMemberInfo`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }

        // if (msisdn === "" || (data?.msisdn && msisdn !== data.msisdn)) {
        if (localStorage?.getItem('mobile') === "" || (data?.msisdn && msisdn !== data.msisdn)) {
            dataHandle = {
                ...dataHandle,
                msisdn: data?.msisdn,
            }
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + secretKey).toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    getMembershipPrivileges: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/getMembershipPrivileges`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    getHistory: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/getHistory`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + dataHandle?.startDate + "|" + dataHandle?.endDate + "|" + dataHandle?.pageSize + "|" + dataHandle?.pageNo + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    getPromotionalCategories: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/getPromotionalCategories`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + secretKey).toString(cryptoJs.enc.Hex)
        }
        return postRequestLoyalty(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    getMyRewards: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/getMyRewards`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + dataHandle?.pageSize + "|" + dataHandle?.pageNo + "|" + dataHandle?.screen + "|" + secretKey).toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    getDetailRewards: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/getDetailRewards`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + dataHandle?.giftId + "|" + dataHandle?.transactionId + "|" + secretKey).toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    getDetailRewardsForVplus: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/getDetailRewardsForVplus`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + dataHandle?.chuongTrinhUuDaiId + "|" + secretKey).toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    trackingShipment: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/trackingShipment`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId
                + "|" + dataHandle?.msisdn
                + "|" + dataHandle?.session
                + "|" + dataHandle?.type
                + "|" + dataHandle?.transactionId
                + "|" + dataHandle?.startDate
                + "|" + dataHandle?.endate
                + "|" + dataHandle?.campaignDetailCode
                + "|" + dataHandle?.userHashCode
                + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    locationCatalog: function (data, headers, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/locationCatalog`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        // case ko login chưa có sđt vs session sẽ fake chuỗi bất kỳ để tránh lỗi API input trống.
        dataHandle.msisdn = dataHandle?.msisdn ? dataHandle?.msisdn : "a";
        dataHandle.session = dataHandle?.session ? dataHandle?.session : "a";

        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId
                + "|" + dataHandle?.msisdn
                + "|" + dataHandle?.session
                + "|" + dataHandle?.locationType
                + "|" + dataHandle?.locationCode
                + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequestLoyalty(URL, dataHandle, {headers: {...setHeaders(), ...headers}}, successCallback, failCallback, null);
    },

    businessCatalog: function (data, headers, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/businessCatalog`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        // case ko login chưa có sđt vs session sẽ fake chuỗi bất kỳ để tránh lỗi API input trống.
        dataHandle.msisdn = dataHandle?.msisdn ? dataHandle?.msisdn : "a";
        dataHandle.session = dataHandle?.session ? dataHandle?.session : "a";

        dataHandle = {
            ...dataHandle,
            secureCode: sha256(
                dataHandle?.requestId
                + "|" + dataHandle?.msisdn
                + "|" + dataHandle?.session
                + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequestLoyalty(URL, dataHandle, {headers: {...setHeaders(), ...headers}}, successCallback, failCallback, null);
    },

    registerForPartner: function (data, headers, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/registerForPartner`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        // case ko login chưa có sđt vs session sẽ fake chuỗi bất kỳ để tránh lỗi API input trống.
        dataHandle.msisdn = dataHandle?.msisdn ? dataHandle?.msisdn : "a";
        dataHandle.session = dataHandle?.session ? dataHandle?.session : "a";

        dataHandle = {
            ...dataHandle,
            secureCode: sha256(
                dataHandle?.requestId
                + "|" + dataHandle?.msisdn
                + "|" + dataHandle?.session
                + "|" + dataHandle?.businessName
                + "|" + dataHandle?.contactPhoneNumber
                + "|" + dataHandle?.province
                + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequestLoyalty(URL, dataHandle, {headers: {...setHeaders(), ...headers}}, successCallback, failCallback, null);
    },

    registerMember: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/registerMember`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session
                + "|" + dataHandle?.dateOfBirth + "|" + dataHandle?.gender + "|" + dataHandle?.identifierType + "|" + dataHandle?.identifier
                + "|" + dataHandle?.identifierIssuedDate + "|" + dataHandle?.email + "|" + dataHandle?.provinceId + "|" + dataHandle?.wardId
                + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    cancelMember: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/cancelMember`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    rewardHub: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/rewardHub`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + secretKey).toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    issueRewardWithDelivery: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/issueRewardWithDelivery`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + dataHandle?.campaignDetailCode
                + "|" + dataHandle?.productNumber + "|" + dataHandle?.presentMapId + "|" + dataHandle?.quantity + "|" + dataHandle?.description
                + "|" + dataHandle?.quantity + "|" + dataHandle?.isPermitted + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    checkConditionsTransferPoint: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/checkConditionsTransferPoint`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + dataHandle?.phoneNumberReceiver
                + "|" + dataHandle?.transferPoint + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    transferPoint: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/transferPoint`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + dataHandle?.phoneNumberReceiver
                + "|" + dataHandle?.transferPoint + "|" + dataHandle?.description + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    getServicesAccumulatingPoints: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/getServicesAccumulatingPoints`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(dataHandle?.requestId + "|" + dataHandle?.msisdn + "|" + dataHandle?.session + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    },

    ratings: function (data, successCallback, failCallback) {
        const URL = `${baseURLVPlusLoyalty}/ratings`;
        let dataHandle = {
            ...setRequest(),
            ...data
        }
        dataHandle = {
            ...dataHandle,
            secureCode: sha256(
                dataHandle?.requestId
                + "|" + dataHandle?.msisdn
                + "|" + dataHandle?.session
                + "|" + dataHandle?.ratingType
                + "|" + dataHandle?.targetRating
                + "|" + dataHandle?.campaignDetailCode
                + "|" + dataHandle?.productNumber
                + "|" + dataHandle?.giftId
                + "|" + dataHandle?.detailGiftId
                + "|" + dataHandle?.transactionId
                + "|" + dataHandle?.ratingScore
                + "|" + dataHandle?.ratingComment
                + "|" + secretKey)?.toString(cryptoJs.enc.Hex)
        }
        return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    }

};